import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { forwardRefAndName } from "../../../../lib/forwardRefAndName";
import { BaseIcon } from "../../BaseIcon";
export var MarkupIcon32Regular = forwardRefAndName('MarkupIcon32Regular', function (props, ref) {
  return /*#__PURE__*/(
    React.createElement(BaseIcon, _extends({
      ref: ref,
      viewBoxSize: 32
    }, props), /*#__PURE__*/
    React.createElement("path", {
      d: "M13.6395 13.0605C14.0301 13.451 14.0301 14.0842 13.6395 14.4747L10.4678 17.6464C10.2725 17.8417 10.2725 18.1583 10.4678 18.3536L13.6395 21.5253C14.0301 21.9158 14.0301 22.549 13.6395 22.9395C13.249 23.3301 12.6158 23.3301 12.2253 22.9395L9.05355 19.7678C8.07724 18.7915 8.07724 17.2085 9.05355 16.2322L12.2253 13.0605C12.6158 12.6699 13.249 12.6699 13.6395 13.0605Z"
    }), /*#__PURE__*/
    React.createElement("path", {
      d: "M18.3605 14.4747C17.97 14.0842 17.97 13.451 18.3605 13.0605C18.751 12.6699 19.3842 12.6699 19.7747 13.0605L22.9465 16.2322C23.9228 17.2085 23.9228 18.7915 22.9465 19.7678L19.7747 22.9395C19.3842 23.3301 18.751 23.3301 18.3605 22.9395C17.97 22.549 17.97 21.9158 18.3605 21.5253L21.5323 18.3536C21.7275 18.1583 21.7275 17.8417 21.5323 17.6464L18.3605 14.4747Z"
    }), /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4 7.5C4 4.46243 6.46243 2 9.5 2H18.2261C19.287 2 20.3044 2.42143 21.0546 3.17157L26.8284 8.94543C27.5786 9.69558 28 10.713 28 11.7739V24.5C28 27.5376 25.5376 30 22.5 30H9.5C6.46243 30 4 27.5376 4 24.5V7.5ZM9.5 4C7.567 4 6 5.567 6 7.5V24.5C6 26.433 7.567 28 9.5 28H22.5C24.433 28 26 26.433 26 24.5V11.7739C26 11.2434 25.7893 10.7347 25.4142 10.3596L19.6404 4.58579C19.2653 4.21071 18.7566 4 18.2261 4H9.5Z"
    }))
  );
});